import { ACTION_TYPE } from '../../core/redux/actionType';
import { updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { apiReplayGuestHydrationErrors } from '../../core/redux/api/endpoints';
import { addError, addLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { ApiReducer, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { IAppState } from '../../core/redux/IAppState';


const KEY_ACTION = ACTION_TYPE.REPLAY_GUEST_HYDRATION_ERRORS_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.REPLAY_GUEST_HYDRATION_ERRORS_REQUEST,
  ACTION_TYPE.REPLAY_GUEST_HYDRATION_ERRORS_RESPONSE,
  ACTION_TYPE.REPLAY_GUEST_HYDRATION_ERRORS_ERROR,
];


/**
 * Makes an action that can be dispatched to replay guest hydration errors for the specified resort.
 */
export const replayGuestHydrationErrorsAction = (
  resortAbbrev: string,
  masterGuestId: string,
) => makeApiAction(
  {
    endpoint: apiReplayGuestHydrationErrors(resortAbbrev, masterGuestId),
    method:   'POST',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { resortAbbrev, masterGuestId } })) as RsaaTypes,
    bailout:  (state: IAppState) => false,
  },
);


const reducer: ApiReducer<any> = (state, action, error, isLoading, payload): IAppState => {
  const replayRequestId =  `${action.meta.resortAbbrev}_${action.meta.masterGuestId}`;

  if (isLoading) {
    return addLoading(state, replayRequestId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(
      withBreaker,
      replayRequestId,
      KEY_ACTION,
      error
    );
  };

  const noLoadingOrError = removeLoadingAndError(withBreaker, replayRequestId, KEY_ACTION);

  return noLoadingOrError;
};


/**
 * Function that maps actions into new app state. Specifically, updates app state with information from actions related
 * to product hydration errors. Returns a new app state.
 */
export const replayGuestHydrationErrorsReducer = makeApiReducer<any>(ACTIONS, KEY_ACTION, reducer);
